import { z } from 'zod';

const FileDesignRequestSchema = z.object({
  describeYourIdea: z.string().min(1),
  fonts: z.array(z.string()).min(1).max(2),
  colors: z.array(z.string()).min(1).max(3),
  template: z.string().min(1),
  attachments: z.array(z.string()).optional(),
});

export {
  FileDesignRequestSchema,
};
